module.exports = __webpack_public_path__ + "img/pauli-x-root-3.a47793b6.svg";